import React from 'react';
import {
  Alert,
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControlLabel,
  Typography,
} from '@mui/material';
import { FRENCH_FIRST_LOGIN_TERMS } from '../utils/agencyTermsAcceptance';

interface AgencyTermsDialogProps {
  open: boolean;
  accepted: boolean;
  onAcceptedChange: (accepted: boolean) => void;
  onAccept: () => void;
  onReject: () => void;
}

const AgencyTermsDialog: React.FC<AgencyTermsDialogProps> = ({
  open,
  accepted,
  onAcceptedChange,
  onAccept,
  onReject,
}) => {
  return (
    <Dialog open={open} onClose={onReject} fullWidth maxWidth="md">
      <DialogTitle sx={{ fontWeight: 800, color: '#1F2937' }}>
        Conditions d'utilisation et limitation de responsabilite
      </DialogTitle>
      <DialogContent dividers sx={{ pt: 2 }}>
        <Typography variant="body1" sx={{ mb: 2, fontWeight: 700, color: '#273B7D' }}>
          Lecture obligatoire avant l'acces au compte agence
        </Typography>
        <Typography variant="body2" sx={{ mb: 2, color: 'text.secondary' }}>
          Le texte ci-dessous est volontairement direct. Il encadre l'usage du systeme a un niveau general et rappelle que la responsabilite operationnelle, commerciale et documentaire reste du cote de l'agence utilisatrice.
        </Typography>
        <Divider sx={{ mb: 2 }} />
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.75 }}>
          {FRENCH_FIRST_LOGIN_TERMS.map((paragraph, index) => (
            <Typography key={index} variant="body2" sx={{ lineHeight: 1.75, color: '#111827' }}>
              {index + 1}. {paragraph}
            </Typography>
          ))}
        </Box>
        <Alert severity="warning" sx={{ mt: 3 }}>
          En continuant, vous confirmez avoir lu, compris et accepte ces conditions pour le compte de votre agence.
        </Alert>
        <FormControlLabel
          sx={{ mt: 2, alignItems: 'flex-start' }}
          control={
            <Checkbox
              checked={accepted}
              onChange={(event) => onAcceptedChange(event.target.checked)}
            />
          }
          label="Je reconnais avoir lu et accepte les conditions ci-dessus."
        />
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onReject} color="inherit">
          Refuser
        </Button>
        <Button
          onClick={onAccept}
          variant="contained"
          disabled={!accepted}
          sx={{ bgcolor: '#273B7D', '&:hover': { bgcolor: '#1E2D5F' } }}
        >
          Accepter et continuer
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AgencyTermsDialog;